/**
 * @module TeamCard
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import getOpenRolesLabel from '../helpers/getOpenRolesLabel';

const careersTeamsPath = 'lc-site/careers/teams';
const teamsImages = {
  'business-operations': `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/BusStrat_Sm.jpg`,
  'creative-content-communications': `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/CMComm_Sm.jpg`,
  'digital-technology': `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/Tech_Sm.jpg`,
  internships: `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/Internships_Sm.jpg`,
  'location-support': `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/Locations_Sm.jpg`,
  ministry: `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/Ministry_Sm.jpg`,
  'staff-childcare': `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/StaffKids_Sm.jpg`,
  youversion: `${process.env.IMGIX_BASE_URL}/${careersTeamsPath}/YV_Sm.jpg`,
};

/**
 * Represents a team information card for the Careers teams page.
 *
 * @param {object} props - The component props object.
 * @param {Team} props.team - The team data object.
 *
 * @returns {React.ReactElement} The TeamCard component.
 */
export default function TeamCard({ team }) {
  if (!team) {
    return null;
  }

  const { id, openRoles = 0, teamName } = team;
  const { main, prefix } = getOpenRolesLabel(openRoles);

  return (
    <div className="team-card px-normal mb-bit_more_relaxed">
      <a href={`/careers/team?name=${teamName}`}>
        <img alt={teamName} src={teamsImages[id]} />
        <h4 className="px-normal mt-normal mb-tighter">{teamName}</h4>
        <p className="px-normal mb-bit_more_relaxed">
          {prefix} {main}
        </p>
      </a>
    </div>
  );
}
